import { isControlEditPage } from "../control-edit-page";

export class Storage {
  constructor() {
    this.storage = window.localStorage || InMemoryStorage();
  }

  getItem(key) {
    return this.storage.getItem(key);
  }

  setItem(key, value) {
    this.storage.setItem(key, value);
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }
}

export class SessionStorage {
  constructor() {
    // On the control-edit page the session lives in memory from the start: the
    // tab's session storage may hold an applicant's session (control-edit-page.js).
    this.storage = isControlEditPage ? InMemoryStorage() : window.sessionStorage || InMemoryStorage();
  }

  getItem(key) {
    return this.storage.getItem(key);
  }

  setItem(key, value) {
    this.storage.setItem(key, value);
  }

  removeItem(key) {
    this.storage.removeItem(key);
  }
}

// Same contract as window.sessionStorage: a missing key reads as null.
const InMemoryStorage = () => {
  let data = {};
  return {
    setItem: (key, val) => {
      data[key] = String(val);
    },
    getItem: (key) => {
      return Object.prototype.hasOwnProperty.call(data, key) ? data[key] : null;
    },
    removeItem: (key) => {
      delete data[key];
    },
    clear: () => {
      data = {};
    },
  };
};
